// This is a mock API. In a real application, you would fetch this data from a server.

const sampleHoroscopes = {
  today: {
    aries: '今天充满活力，适合开展新项目。财运不错，但要注意不要冲动消费。',
    taurus: '感情运势佳，可能会有浪漫的邂逅。工作上需要多一点耐心。',
    gemini: '思维活跃，适合学习和交流。注意言多必失，避免与人发生口角。',
    // ... add more for other signs
  },
  week: {
    aries: '本周是充满机遇的一周，大胆去尝试新事物吧。健康方面需要注意休息。',
    // ...
  },
  month: {
    aries: '本月你的事业运将达到高峰，之前的努力会得到回报。',
    // ...
  }
};

export const getHoroscope = (sign, period) => {
  return new Promise((resolve) => {
    // Simulate a network delay
    setTimeout(() => {
      const horoscopeText = sampleHoroscopes[period]?.[sign] || '暂无此星座的运势信息，我们会尽快更新。';
      resolve(horoscopeText);
    }, 500);
  });
};
